export default "__VITE_ASSET__BL0VIiLH__"